/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.actor.declaration'

export { $nsid }

/** A declaration of a Bluesky chat account. */
type Main = {
  $type: 'chat.bsky.actor.declaration'
  allowIncoming: 'all' | 'none' | 'following' | l.UnknownString
}

export type { Main }

/** A declaration of a Bluesky chat account. */
const main = l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  l.object({
    allowIncoming: l.string<{ knownValues: ['all', 'none', 'following'] }>(),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
